import { EventEmitter, Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class PaginatorService {
  paginatorConfig = {
    pageSize: 10,
    length: 0,
    pageSizeOptions: [10, 20, 30, 40,50],
    pageIndex: 0
  };
  DefaultPageSize=10;
  paginationEvent: EventEmitter<any> = new EventEmitter<any>();
  lengthChange: EventEmitter<number> = new EventEmitter<number>();
  emitPaginationEvent(event: any): void {
    this.paginationEvent.emit(event);
  }
  setLength(Length: number): void {
    this.paginatorConfig.length = Length;
    this.lengthChange.emit(Length);
  }
}
